module.exports = __webpack_public_path__ + "img/301vidas.4963da8c.png";